import styled from 'styled-components';
import { style } from '../../../style';
import { transparent } from 'material-ui/styles/colors';

export const Menu = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 60px;
  padding: 0px 100px 0px 75px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  width: 100;
  justify-content: space-between;

  font-family: 'Rubik';
`;

export const MenuOption = styled.button`
  position: relative;
  border: none;
  background: none;
  padding: 10px 5px;
  font-size: 16px;
  cursor: pointer;
  color: #87868a;
  height: 38px;

  &.active {
    color: #2e63fb;
    border-bottom: 1px solid #2e63fb;
  }

  &:hover {
    color: #2e63fb;
  }
`;
